import Vue from "vue"

export default {
  mounted: function () {
    if (process.client) {
      window.intercomSettings = {
        app_id: "mymph3uf",
        custom_launcher_selector: "#custom_intercom_button",
      }

      this.intercom_setLoggedInSettings()
      if (window.location.pathname.match("/influencer/widget") === null) {
        ;(function () {
          var w = window
          var ic = w.Intercom

          if (typeof ic === "function") {
            ic("reattach_activator")
            ic("update", w.intercomSettings)
          } else {
            var d = document
            var i = function () {
              i.c(arguments)
            }

            i.q = []
            i.c = function (args) {
              i.q.push(args)
            }
            w.Intercom = i
            var l = function () {
              var s = d.createElement("script")
              s.type = "text/javascript"
              s.async = true
              s.src = "https://widget.intercom.io/widget/mymph3uf"
              var x = d.getElementsByTagName("script")[0]
              x.parentNode.insertBefore(s, x)
            }
            l()
          }
        })()
      }
    }
  },
  methods: {
    intercom_setLoggedInSettings: function () {
      if (this.$store.getters["user/IS_LOGGED_IN"]) {
        window.intercomSettings.name = this.$store.state.user.first_name
        window.intercomSettings.email = this.$store.state.user.email
        window.intercomSettings.user_id = this.$store.state.user.id
        window.intercomSettings.percent_1 = this.$store.state.user.id % 100 < 1
        window.intercomSettings.percent_2 = this.$store.state.user.id % 100 < 2
        window.intercomSettings.percent_5 = this.$store.state.user.id % 100 < 5
        window.intercomSettings.percent_10 =
          this.$store.state.user.id % 100 < 10
        window.intercomSettings.percent_25 =
          this.$store.state.user.id % 100 < 25
        window.intercomSettings.percent_50 =
          this.$store.state.user.id % 100 < 50
        window.intercomSettings.percent_75 =
          this.$store.state.user.id % 100 < 75
        window.intercomSettings.percent_100 =
          this.$store.state.user.id % 100 <= 100
        window.intercomSettings.avatar = {
          type: "avatar",
          image_url: this.$store.getters["user/PICTURE"],
        }
        window.intercomSettings.submissions = this.$store.state.user.submissions.reduce(
          (a, b) => {
            return a + b
          },
          0
        )
        window.intercomSettings.answer_submissions =
          window.intercomSettings.submissions -
          this.$store.state.user.submissions[0]
        window.intercomSettings.first_payment_date = this.$store.state.user.first_payment_date
        window.intercomSettings.companies = this.companies
      }
    },
    intercom_genId: function (input) {
      var output = ""

      for (let i = 0; i < input.length; i++) output += input[i].charCodeAt(0)
      return output
    },
  },
  computed: {
    companies: function () {
      var ret = []

      if (this.$store.getters["user/IS_LOGGED_IN"]) {
        if (this.$store.getters["user/KIND"] === "band") {
          for (
            var i = this.$store.state.user.band_set.length - 1;
            i >= 0;
            i--
          ) {
            const band = this.$store.state.user.band_set[i]

            ret.push({
              type: "company",
              company_id: this.intercom_genId(band.name) + band.id,
              name: band.name,
              industry: this.$store.state.user.agency.kind,
              first_submission_date:
                band.first_submission_date === null
                  ? null
                  : new Date(band.first_submission_date).getTime() / 1000,
              latest_submission_date:
                band.latest_submission_date === null
                  ? null
                  : new Date(band.latest_submission_date).getTime() / 1000,
            })
          }
        } else if (this.$store.getters["user/KIND"] === "influencer") {
          const inf = this.$store.state.user.influencer

          ret.push({
            type: "company",
            company_id: this.intercom_genId(inf.entity) + inf.id,
            name: inf.entity,
            industry: "influencer",
            remote_created_at: inf.date_joined,
          })
        }
      }
      return ret
    },
  },
}
